import { createRateLimiter } from '@griply/utils';
import * as Sentry from '@sentry/react';
import { version } from 'shared/constants';

const parseSampleRate = (raw: string | undefined, fallback: number): number => {
  if (!raw) {
    return fallback;
  }
  const parsed = parseFloat(raw);
  if (Number.isNaN(parsed)) {
    return fallback;
  }
  return parsed;
};

let initialized = false;

export const init = () => {
  if (initialized) {
    return;
  }
  initialized = true;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.VITE_ENVIRONMENT;
  const enabled = environment !== 'local' && !!dsn;

  Sentry.init({
    dsn,
    enabled,
    environment,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    sampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_SAMPLE_RATE, 1.0),
    tracesSampleRate: parseSampleRate(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
      0.1,
    ),
    sendDefaultPii: false,
    beforeSend: createRateLimiter({ itemsPerMinute: 10, maxItems: 20 }),
    integrations: [Sentry.browserTracingIntegration()],
    _experiments: { enableLogs: true },
    initialScope: {
      tags: { appVersion: version },
    },
  });
};
